import { useEffect, useState } from "react";
import { Line } from "react-chartjs-2";
import axios from "axios";
import { url, auth_key, user_id } from "../../../constants";

const getCompanyChartDetails = async (ISIN, yearlyView, monthlyView) => {
  try {
    const response = await axios.get(
      yearlyView
        ? `${url}company/24/${ISIN}`
        : monthlyView
        ? `${url}company/30/${ISIN}`
        : `${url}company/13/${ISIN}`,
      {
        headers: {
          "X-Api-Key": auth_key,
        },
        params: {
          User_ID: user_id,
        },
      }
    );
    return response?.data;
  } catch (error) {
    console.log(error);
  }
};

const DetailedChart = (props) => {
  const yearlyView = props.yearlyView;
  const monthlyView = props.monthlyView;
  const [historical_data, setHistorical_data] = useState([]);
  const [dateLabels, setDateLabels] = useState([]);
  const changeGraph = props.changeGraph;

  useEffect(async () => {
    const _dataset = await getCompanyChartDetails(
      props.ISIN,
      yearlyView,
      monthlyView
    );
    var dataArray = [];
    var dateArray = [];
    _dataset?.Historical_data?.map((item) => {
      dataArray.push(item.values);
      const labels = item.date.split("-");
      dateArray.push(
        yearlyView ? `${labels[1]}.${labels[0]}.` : `${labels[2]}.${labels[1]}.`
      );
    });
    setHistorical_data([...dataArray]);
    setDateLabels([...dateArray]);
  }, [changeGraph, props.ISIN]);

  const data = () => {
    return {
      labels: [...dateLabels],
      datasets: [
        {
          data: [...historical_data],
          fill: false,
          borderColor: "#0040ff",
          pointRadius: 0,
          lineTension: 0.1,
          borderWidth: 2,
        },
      ],
    };
  };

  return (
    <div
      style={{
        width: "99.9%",
        height: "122px",
        backgroundColor: "#fff",
      }}
    >
      <Line
        data={data}
        legend={{
          display: false,
        }}
        options={{
          responsive: true,

          maintainAspectRatio: false,
          // layout: {
          //   padding: 20,
          // },
          scales: {
            xAxes: [
              {
                gridLines: {
                  display: false,
                },
                ticks: {
                  maxRotation: 0,
                  maxTicksLimit: 5,
                  fontSize: 10,
                },
              },
            ],
            yAxes: [
              {
                gridLines: {
                  display: true,
                  color: "#fafbfb",
                  zeroLineColor: "#fafbfb",
                },
                ticks: {
                  maxTicksLimit: 3,
                  stepSize:
                    data?.max - data?.min > 10
                      ? Math.floor((data?.max - data?.min) / 5)
                      : (data?.max - data?.min) / 8,
                  fontSize: 10,
                },
              },
            ],
          },
        }}
      />
    </div>
  );
};

export default DetailedChart;
